import { AfterViewChecked, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-choice-answer',
  templateUrl: './choice-answer.component.pug',
  styleUrls: ['./choice-answer.component.scss'],
  standalone: false
})
export class ChoiceAnswerComponent implements OnInit, AfterViewChecked {
  @Input() options: any;
  @Output() disableSave:EventEmitter<any> = new EventEmitter();
  option = {
    'placeholder': $localize`Enter an option`,
    'text': '',
    'comments_required': true
  };
  constructor() { }

  ngOnInit(): void {
  }
  ngAfterViewChecked(){
    for (let i = 0; i < this.options.options.length; i++) {
      const option = this.options.options[i];
      if (!option.text) {
        this.disableSave.emit(true);
        return
      }
    }
    this.disableSave.emit(false);
  }

  addOption(index){
    this.options.options.splice(index+1, 0, {...this.option});
  }

  removeOption(index){
    if(this.options.options.length<=2){
      return;
    }
    this.options.options.splice(index, 1);
  }
}
